import React from 'react';
import {useAppSelector} from '../../DAL/store';
import {rootActions, useAppDispatch} from '../../../account/change-sbs-billing-info/data/store';
import {sendGAEvent} from '../../../../domain/marketing/gtm-provider';
import {SubscriptionPlanModel} from "../../interfaces";
import ProductPriceFormat from "../../../products/product-price/product-price-format";

interface ITwoMonthFreeProps {
    PlanAnnual:  SubscriptionPlanModel,
    PlanMonthly:  SubscriptionPlanModel
}
const TwoMonthFree = (props: ITwoMonthFreeProps) => {
    const dispatch = useAppDispatch();
    const IsAnnual = useAppSelector((store) => store.IsAnnual);

    const PlanSave = Number(((props.PlanMonthly.skU_MSRP * 12) - props.PlanAnnual.skU_MSRP).toFixed(2));
    //console.log('TwoMonthFree PlanSave: ',PlanSave);

    const openPopup = () => {
        dispatch(
            rootActions.main({
                IsTwoMonthFreePopupShown: true,
                PlanSavePopupShown: PlanSave,
                PlanCostPopupShown: props.PlanAnnual.skU_MSRP
            })
        );

        sendGAEvent('Click','You’re save 2 months free');
    };

    const goToAnnual = () => {
        dispatch(
            rootActions.main({
                IsAnnual: true,
            })
        );

        sendGAEvent('Click','Pay annually & save 2 months');
    };

    return (
        <div className="flex items-center justify-center mt-5 lg:mt-4">

            {
                IsAnnual &&
                <div className="text-center text-base lg:text-xl">
                    <span className="you-save">You save </span>
                    <button
                        type="button"
                        // className="underline cursor-pointer text-yellow-400"
                        className="you-save-price underline cursor-pointer text-white"
                        onClick={ openPopup }><ProductPriceFormat price={ PlanSave } /> a year</button>

                </div>
            }

            {
                !IsAnnual &&
                <div className="text-center text-base lg:text-xl">
                    <button
                        type="button"
                        onClick={ goToAnnual }
                        className="underline cursor-pointer">
                        Pay annually
                    </button>
                    <span> &amp; </span>
                    {/*<span className="text-yellow-400">save <ProductPriceFormat price={ PlanSave } /></span></div>*/}
                    <span>save <ProductPriceFormat price={ PlanSave } /></span></div>
            }
        </div>
    )
};

export default TwoMonthFree;